import { CanActivateFn } from '@angular/router';
import { NEW_EXPERIENCE_ID } from '../../shared/constants/experience.constants';
import { tenantAdminGuard } from './tenant-admin.guard';

/** Creating an experience is owner-only; staff may still open an existing one. */
export const newExperienceGuard: CanActivateFn = (route, state) =>
  route.paramMap.get('id') === NEW_EXPERIENCE_ID ? tenantAdminGuard(route, state) : true;
